import { Tooltip } from 'antd';
import React from 'react';

import { ICurrency } from 'src/apis/common';
import { IBasicPlanResponseCents } from 'src/apis/plans';
import NumericalPlanProperty from '../NumericalPlanProperty';
import PricePlanProperty from '../PricePlanProperty';

import './MaDirectPlan.scss';

export interface IProps {
  currency: ICurrency;
  productsAndOverages: IBasicPlanResponseCents;
  includedMailSyncSeats: number|null;
}

const ProductsAndOverages: React.FC<IProps> = (props) => {
  const {currency, productsAndOverages} = props;
  // Convert null to undefined as required for the input.
  const includedMailSyncSeats = props.includedMailSyncSeats === null ? undefined : props.includedMailSyncSeats;
  return <section className={'products-and-overages'}>
    <h3>Products & Overages</h3>
    <div className={'plan-properties'}>
      <label>Page Impressions:</label>
      <div className={'properties-group'}>
        <NumericalPlanProperty label={'Impression Limit'} value={productsAndOverages.pageImpressionsLimit}/>
        <PricePlanProperty currency={currency} label={'Overage Price'}
                           value={productsAndOverages.pageImpressionsOveragePrice}/>
        <NumericalPlanProperty label={'Pages per Overage Price'} value={productsAndOverages.pageImpressionsMultiplier}/>
      </div>
      <label>Mail Sync:</label>
      <div className={'properties-group'}>
        <PricePlanProperty currency={currency} label={'Price'} value={productsAndOverages.mailboxSyncPrice}/>
        <NumericalPlanProperty label={'Included Seats'} value={includedMailSyncSeats}/>
      </div>
      <label>Sales Dialer:</label>
      <div className={'properties-group'}>
        <PricePlanProperty currency={currency} label={'Price'}
                           value={productsAndOverages.salesDialerPrice}/>
        <NumericalPlanProperty label={'Included Seats'} value={productsAndOverages.includedSalesDialerSeats}/>
      </div>
      <label>Other:</label>
      <div className={'properties-group'}>
        <PricePlanProperty currency={currency} label={'Salesforce Price'} value={productsAndOverages.externalCRMPrice}/>
        <PricePlanProperty
          currency={currency}
          label={<Tooltip title={'per 1,000 leads'}>Lead Overage Price</Tooltip>}
          value={productsAndOverages.leadOveragePricePerThousand}
        />
      </div>
    </div>
  </section>
}

export default ProductsAndOverages;
